var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', _vm._b({
    attrs: {
      "persistent": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var _vm$value;
        var attrs = _ref.attrs,
          on = _ref.on;
        return [_vm.$scopedSlots['activator'] ? [_vm._t("activator", null, null, {
          attrs,
          on
        })] : [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "x-small": "",
            "block": "",
            "tile": "",
            "color": "transparent",
            "width": "100%",
            "height": "100%"
          }
        }, 'v-btn', Object.assign({}, attrs, {
          title: _vm.title_activator
        }), false), on), [(_vm$value = _vm.value) !== null && _vm$value !== void 0 && _vm$value.data ? _c('span', [_vm._v(" " + _vm._s(_vm.value.data) + " ")]) : _c('span', {
          staticStyle: {
            "opacity": "0.5",
            "word-break": "auto-phrase"
          }
        }, [_vm._v(" " + _vm._s(_vm.value.term) + " ")])])]];
      }
    }], null, true),
    model: {
      value: _vm.shows,
      callback: function ($$v) {
        _vm.shows = $$v;
      },
      expression: "shows"
    }
  }, 'v-dialog', {
    width: _vm.width
  }, false), [_c('v-card', [_c('v-card-title', [_vm._v(" \"" + _vm._s(_vm.value.term) + "\" 입력 ")]), _c('v-card-text', [_vm._t("default", null, null, {
    save: _vm.save
  })], 2), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "x-small": "",
      "text": "",
      "tile": "",
      "color": "error"
    },
    on: {
      "click": _vm.exit
    }
  }, [_vm._v("취소하기")]), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "x-small": "",
      "text": "",
      "tile": "",
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("저장하기")])], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }